"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1813],{

/***/ 71813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Frame": function() { return /* reexport */ Frame; },
  "GameFrame": function() { return /* reexport */ GameFrame; },
  "LeftCarousel": function() { return /* reexport */ LeftCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 5 modules
var AppContext = __webpack_require__(24911);
// EXTERNAL MODULE: ./src/types/enum.ts
var types_enum = __webpack_require__(95753);
;// CONCATENATED MODULE: ./src/utils/add-or-replace-params.ts
/**
 * Add a URL parameter (or modify if already exists)
 * @param {String} url
 * @param {String} param
 * @param {String} value
 */ var addOrReplaceParam = function(url, param, value) {
    // eslint-disable-next-line no-param-reassign
    param = encodeURIComponent(param);
    var r = "([&?]|&amp;)".concat(param, "\\b(?:=(?:[^&#]*))*");
    var a = document.createElement("a");
    var regex = new RegExp(r);
    var str = param + (value ? "=".concat(encodeURIComponent(value)) : "");
    a.href = url;
    var q = a.search.replace(regex, "$1".concat(str));
    if (q === a.search) {
        a.search += (a.search ? "&" : "") + str;
    } else {
        a.search = q;
    }
    return a.href;
};

// EXTERNAL MODULE: ./src/utils/ancestor/index.js + 3 modules
var utils_ancestor = __webpack_require__(40895);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(18714);
// EXTERNAL MODULE: ./node_modules/screenfull/index.js
var screenfull = __webpack_require__(47489);
;// CONCATENATED MODULE: ./src/components/OrientationLock/OrientationLock.tsx











/**
 * Set the orientation lock. ONLY allowed when the application is in fullscreen mode.
 * When fullscreen is disabled the orientation lock will automatically revert to 'any'
 * or whatever the default of the web application manifest has set.
 *
 * @param {fullscreenElement} fullscreenElement
 * @param {GameOrientationEnum} requestedOrientation
 * @returns {Promise<void>}
 * @public
 */ var setScreenLock = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(fullscreenElement, requestedOrientation) {
        var ref, error, error1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(screenfull/* default.isEnabled */.Z.isEnabled && !screenfull/* default.isFullscreen */.Z.isFullscreen)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        screenfull/* default.request */.Z.request(fullscreenElement)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    // Silently fail.
                    console.error(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    if (!(typeof (window === null || window === void 0 ? void 0 : window.safari) === "undefined" && // @ts-ignore
                    (!screenfull/* default.isEnabled */.Z.isEnabled || screenfull/* default.isFullscreen */.Z.isFullscreen) && (screen === null || screen === void 0 ? void 0 : (ref = screen.orientation) === null || ref === void 0 ? void 0 : ref.lock) && typeof screen.orientation.lock === "function" && ("orientation" in screen || "mozOrientation" in screen || "msOrientation" in screen) && [
                        types_enum/* GameOrientationEnum.LANDSCAPE */.lD.LANDSCAPE,
                        types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
                    ].includes(requestedOrientation))) return [
                        3,
                        8
                    ];
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    // @ts-ignore
                    return [
                        4,
                        screen.orientation.lock(requestedOrientation)
                    ];
                case 6:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 7:
                    error1 = _state.sent();
                    // @ts-ignore
                    throw new Error(error1);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function setScreenLock(fullscreenElement, requestedOrientation) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * First undo screen orientation lock. Then remove fullscreen.
 * @returns {Promise<void>}
 */ var unsetScreenLock = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, error, error1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(screenfull/* default.isEnabled */.Z.isEnabled && screenfull/* default.isFullscreen */.Z.isFullscreen)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        screenfull/* default.exit */.Z.exit()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    // @ts-ignore
                    throw new Error(error);
                case 4:
                    if (!(typeof (window === null || window === void 0 ? void 0 : window.safari) === "undefined" && // @ts-ignore
                    (!screenfull/* default.isEnabled */.Z.isEnabled || screenfull/* default.isFullscreen */.Z.isFullscreen) && (screen === null || screen === void 0 ? void 0 : (ref = screen.orientation) === null || ref === void 0 ? void 0 : ref.lock) && typeof screen.orientation.lock === "function" && ("orientation" in screen || "mozOrientation" in screen || "msOrientation" in screen))) return [
                        3,
                        8
                    ];
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        screen.orientation.unlock()
                    ];
                case 6:
                    _state.sent();
                    return [
                        3,
                        8
                    ];
                case 7:
                    error1 = _state.sent();
                    // @ts-ignore
                    throw new Error(error1);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function unsetScreenLock() {
        return _ref.apply(this, arguments);
    };
}();
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14xn9lp0"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        backgroundColor: theme.palette.secondary.main
    };
});
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14xn9lp1"
})(function(param) {
    var theme = param.theme;
    return {
        marginTop: "40px",
        color: theme.palette.common.white,
        textTransform: theme.typography.button.textTransform,
        fontSize: theme.typography.button.fontSize,
        fontFamily: theme.typography.button.fontFamily
    };
});
var Icon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("i", {
    target: "e14xn9lp2"
})(function(param) {
    var theme = param.theme;
    return {
        width: "2rem",
        height: "2rem",
        "& svg": {
            fill: theme.palette.common.white
        }
    };
});
var IconPhone = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14xn9lp3"
})(function(param) {
    var theme = param.theme;
    return {
        height: "50px",
        width: "100px",
        border: "3px solid ".concat(theme.palette.common.white),
        borderRadius: "10px",
        willChange: "transform",
        "@media screen and (orientation: landscape)": {
            animation: "$rotate-device-portrait 1.5s ".concat(theme.transitions.easing.easeInOut, " infinite alternate")
        },
        "@media screen and (orientation: portrait)": {
            animation: "$rotate-device-landscape 1.5s ".concat(theme.transitions.easing.easeInOut, " infinite alternate")
        },
        "@keyframes rotate-device-portrait": {
            "0%": {
                transform: "rotate(0deg)"
            },
            "50%": {
                transform: "rotate(-90deg)"
            },
            "100%": {
                transform: "rotate(-90deg)"
            }
        },
        "@keyframes rotate-device-landscape": {
            "0%": {
                transform: "rotate(-90deg)"
            },
            "50%": {
                transform: "rotate(0deg)"
            },
            "100%": {
                transform: "rotate(0deg)"
            }
        }
    };
});
// Todo: Can't perform a React state update on an unmounted component.
//       This is a no-op, but it indicates a memory leak in your application.
//       To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
var OrientationLock = function(props) {
    var fullscreenElement = props.fullscreenElement, orientation = props.orientation, _zIndex = props.zIndex, zIndex = _zIndex === void 0 ? 2 : _zIndex;
    var t = (0,useTranslation/* useTranslation */.$)("orientation_lock").t;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState({
        match: false,
        lock: types_enum/* GameOrientationEnum.ANY */.lD.ANY,
        lockActive: false,
        fullScreenActive: false
    }), 2), state = ref[0], setState = ref[1];
    ;
    /**
   * Set orientation overlay and values, mainly for iOS web users as they don't have
   * screen.orientation support. This method is usually called from an orientation change
   * or resize event. showOrientationLock() and setScreenLock() can be called at the same
   * time, because orientation-lock element won't show anyway if orientation lock API is working.
   *
   * CSS media query fires before the orientationchange. Hence why we call this method on
   * resize instead.
   */ var showOrientationLock = function() {
        var rotationDirection = types_enum/* GameOrientationEnum.ANY */.lD.ANY;
        if (window.matchMedia("(orientation: ".concat(types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT, ")")).matches) {
            rotationDirection = types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT;
        }
        if (window.matchMedia("(orientation: ".concat(types_enum/* GameOrientationEnum.LANDSCAPE */.lD.LANDSCAPE, ")")).matches) {
            rotationDirection = types_enum/* GameOrientationEnum.LANDSCAPE */.lD.LANDSCAPE;
        }
        if ([
            types_enum/* GameOrientationEnum.LANDSCAPE */.lD.LANDSCAPE,
            types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
        ].includes(orientation)) {
            setState(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    match: orientation === rotationDirection,
                    lock: orientation
                });
            });
        } else {
            setState(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    match: true,
                    lock: types_enum/* GameOrientationEnum.ANY */.lD.ANY
                });
            });
        }
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                lockActive: !state.match
            });
        });
    };
    /**
   * Show fullscreen message, which users can tap to go back into fullscreen and orientation
   * lock if possible.
   */ var showFullscreenState = function() {
        if (!screenfull/* default.isEnabled */.Z.isEnabled) return;
        setState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                fullScreenActive: !screenfull/* default.isFullscreen */.Z.isFullscreen
            });
        });
    };
    /**
   * Set overlays and events to handle fullscreen and screen-lock orientation.
   * Fullscreen API should be called from a user action, hence this needs to be called first.
   * Orientation lock API needs the fullscreen to be enabled already.
   */ react.useEffect(function() {
        var handler = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                setScreenLock(fullscreenElement, orientation)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                showOrientationLock()
                            ];
                        case 2:
                            _state.sent();
                            // await showFullscreenState();
                            document.addEventListener("fullscreenchange", showFullscreenState);
                            window.addEventListener("resize", showOrientationLock);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handler() {
                return _ref.apply(this, arguments);
            };
        }();
        if (fullscreenElement) {
            try {
                handler();
            } catch (error) {
                console.error(error);
            }
        }
        return function() {
            window.removeEventListener("resize", showOrientationLock);
            document.removeEventListener("fullscreenchange", showFullscreenState);
        };
    }, [
        fullscreenElement,
        orientation
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            state.fullScreenActive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
                onClick: function() {
                    return setScreenLock(fullscreenElement, orientation);
                },
                style: {
                    zIndex: zIndex + 1
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: t("tap_for_fullscreen", "Tap for fullscreen")
                    })
                ]
            }),
            state.lockActive && !state.match && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
                style: {
                    zIndex: zIndex
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconPhone, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: t("rotate_your_phone", "Rotate your device")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/OrientationLock/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Fullscreen.js
var Fullscreen = __webpack_require__(55343);
;// CONCATENATED MODULE: ./src/components/GameFrame/styled.tsx

var styled_Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("iframe", {
    target: "eente0w0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minHeight: "100%",
        border: "none",
        backgroundColor: theme.palette.background.paper,
        overflow: "none"
    };
});
var FullScreenButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eente0w1"
})(function() {
    return {
        zIndex: "11",
        fontSize: "25px",
        right: "10px",
        bottom: "10px",
        cursor: "pointer",
        background: "black",
        padding: "5px",
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        opacity: 0.5,
        transition: "0.5s ease",
        "&:hover": {
            opacity: 1
        }
    };
});
var FullScreenNotify = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eente0w2"
})(function() {
    return {
        zIndex: "12",
        background: "rgb(0,0,0)",
        color: "white",
        left: "50%",
        transform: "translate(-50%, 0)",
        position: "absolute",
        top: "10px",
        padding: "10px 15px",
        borderRadius: "10px",
        transition: "0.5s ease"
    };
});

// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(48317);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
;// CONCATENATED MODULE: ./src/components/GameFrame/tapMenu.tsx









var TapMenuContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "exsoo8l0"
})(function() {
    return {
        position: "absolute",
        left: "-12px",
        zIndex: 5,
        bottom: "40px",
        transition: "0.24s"
    };
});
var StyledListItemButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ListItemButton/* default */.Z, {
    target: "exsoo8l1"
})(function() {
    return {
        border: "1px solid #bdbdbd",
        marginBottom: "12px",
        background: "white",
        "&:hover": {
            background: "#fafafa"
        }
    };
});
var TapMenuLinkContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "exsoo8l2"
})(function() {
    return {
        color: "#464646",
        width: "100%"
    };
});
var TapMenu = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), open = ref[0], setOpen = ref[1];
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var tapMenuList = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_tapmenu_list;
    var tapMenuVisible = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_tapmenu_show;
    if (tapMenuVisible && Array.isArray(tapMenuList)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TapMenuContainer, {
                style: {
                    left: open ? "calc(50% - 12px)" : "-12px"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                    onClick: function() {
                        return setOpen(function(prevState) {
                            return !prevState;
                        });
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        src: "/images/game_tap_menu.png",
                        loader: function(param) {
                            var src = param.src;
                            return src;
                        },
                        alt: "game_tap_menu",
                        height: "40",
                        width: "40"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer/* default */.ZP, {
                open: open,
                variant: "persistent",
                anchor: "left",
                PaperProps: {
                    sx: {
                        width: "50%",
                        background: "#ebebeb"
                    }
                },
                sx: {
                    "& .MuiDrawer-root": {
                        position: "absolute"
                    },
                    "& .MuiPaper-root": {
                        position: "absolute"
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* default */.Z, {
                    children: tapMenuList.map(function(param) {
                        var title = param.title, href = param.href;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem/* default */.ZP, {
                            component: Link/* Link */.r,
                            href: href,
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledListItemButton, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TapMenuLinkContainer, {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyboardArrowRight/* default */.Z, {
                                        style: {
                                            fill: "#32acff"
                                        }
                                    })
                                ]
                            })
                        }, title);
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
};
/* harmony default export */ var tapMenu = (TapMenu);

;// CONCATENATED MODULE: ./src/components/GameFrame/Frame.tsx









var Frame = /*#__PURE__*/ react.forwardRef(function(props) {
    var width = props.width, height = props.height, elementWidth = props.elementWidth, elementHeight = props.elementHeight, src = props.src, iframeRef = props.iframeRef;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), fullScreen = ref[0], setFullScreen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), clickIframe = ref1[0], setClickIframe = ref1[1];
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var handleFullScreen = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setFullScreen(function(prevState) {
                    return !prevState;
                });
                // Must show user if game is paused or not
                setClickIframe(true);
                setTimeout(function() {
                    return setClickIframe(false);
                }, 3000);
                return [
                    2
                ];
            });
        });
        return function handleFullScreen() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        var keyDownHandler = function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                setFullScreen(false);
            }
        };
        document.addEventListener("keydown", keyDownHandler);
        return function() {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            (componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_fullscreen_button_is_visible) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenNotify, {
                        style: {
                            opacity: clickIframe ? "0.7" : "0"
                        },
                        children: "Click if you want the game to continue!"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullScreenButton, {
                        onClick: handleFullScreen,
                        style: {
                            position: !fullScreen ? "absolute" : "fixed"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fullscreen/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styled_Root, {
                ref: iframeRef,
                title: "game",
                name: "game",
                src: src,
                allow: "fullscreen",
                sandbox: "allow-scripts allow-orientation-lock allow-same-origin allow-popups",
                "aria-label": "game",
                scrolling: "no",
                width: elementWidth,
                height: elementHeight,
                style: {
                    width: width,
                    height: height,
                    position: !fullScreen ? "absolute" : "fixed",
                    zIndex: !fullScreen ? "inherit" : "10"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tapMenu, {})
        ]
    });
});

;// CONCATENATED MODULE: ./src/components/GameFrame/hardcoded-games.ts

// Todo: HUZ2ERA-1105 - Just update the values for these games in our CMS.
var HARDCODED_GAMES = [
    {
        code: "gd-la-times-daily-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-thomas-joseph-crossword",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-jumble-crossword-daily-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-jumble-crossword-sunday-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-la-times-sunday-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-premier-sunday-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-daily-commuter-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-eugene-sheffer-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-micro-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-observer-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-tv-crossword-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-candy-mahjong-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-mahjong-frenzy-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-candy-rain-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-cookie-crush-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-2020-connect-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-2020-plus-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-2048-lines-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    },
    {
        code: "gd-maya-sg",
        orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
    }, 
];

;// CONCATENATED MODULE: ./src/components/GameFrame/stagePopUp.tsx




var LogoImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "edcyy6y0"
})(function(param) {
    var theme = param.theme;
    return {
        height: "100% !important",
        minHeight: " 100% !important",
        width: "auto !important",
        minWidth: "auto !important",
        margin: "0 !important"
    };
});
var ModalContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edcyy6y1"
})("z-index:5;display:flex;justify-content:center;align-items:start;width:100%;background:#0000006e");
var Modal = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edcyy6y2"
})("margin-top:16px;background:white;width:350px;box-shadow:0 0 10px 0 rgba(0,0,0,0.5);border-radius:12px 12px;text-align:center;");
var ModalHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edcyy6y3"
})("display:flex;width:100%;align-items:center;box-shadow:0 0 10px 0 rgba(0,0,0,0.5);border-radius:12px 12px 0px 0px;padding:0 16px;p{margin-left:8px;}");
var ModalBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edcyy6y4"
})("display:flex;flex-direction:column;margin:16px;");
var StagePopup = function(param) {
    var iconUrl = param.iconUrl, name = param.name, closePopUp = param.closePopUp;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoImage, {
                            loader: function(param) {
                                var src = param.src;
                                return src;
                            },
                            unoptimized: true,
                            width: 40,
                            height: 40,
                            src: "".concat(iconUrl),
                            alt: "logo-inner-url"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                id: "aeriagamesHighscoreTitle",
                                children: name
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalBody, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                            onClick: closePopUp,
                            variant: "contained",
                            style: {
                                background: "#00a2f2",
                                color: "white"
                            },
                            children: "ゲームを続ける"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            style: {
                                marginTop: "24px",
                                color: "#00a1a3",
                                fontSize: "12px",
                                textDecoration: "underline"
                            },
                            href: "https://games.yahoo.co.jp/play",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "かんたんゲーム一覧へ ＞"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(78298);
// EXTERNAL MODULE: ./node_modules/react-rnd/lib/index.js + 2 modules
var lib = __webpack_require__(42663);
;// CONCATENATED MODULE: ./src/components/GameFrame/RedirectBackButton.tsx










var RedirectBackButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e23ygbe0"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "none",
        position: "absolute",
        width: "100vw",
        right: "10px",
        top: "10px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(800), {
        display: "flex",
        justifyContent: "end"
    }), (0,_define_property/* default */.Z)(_obj, "svg", {
        position: "absolute",
        left: "10px",
        top: "8px",
        fill: "white"
    }), _obj;
});
var RedirectImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "e23ygbe1"
})(function() {
    return {
        objectFit: "cover",
        width: "100%",
        height: "100%"
    };
});
var RndContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(lib/* Rnd */.s, {
    target: "e23ygbe2"
})(function() {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1201,
        cursor: "pointer"
    };
});
var RedirectBackButton = function() {
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var redirectImage = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_gamescreen_redirect_back_button_image;
    var redirectUrl = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_gamescreen_redirect_back_button_redirect_url;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), startCoord = ref[0], setStartCoord = ref[1];
    var router = (0,next_router.useRouter)();
    var handleRedirect = function() {
        router.push(redirectUrl || "/");
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RndContainer, {
        className: "12313123123",
        bounds: "parent",
        default: {
            x: 0,
            y: 0,
            width: 72,
            height: 72
        },
        onDragStart: function(_, param) {
            var x = param.x, y = param.y;
            return setStartCoord({
                x: x,
                y: y
            });
        },
        onDragStop: function(_, param) {
            var x = param.x, y = param.y;
            if ((startCoord === null || startCoord === void 0 ? void 0 : startCoord.x) === x && (startCoord === null || startCoord === void 0 ? void 0 : startCoord.y) === y) {
                handleRedirect();
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RedirectBackButtonContainer, {
            children: redirectImage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RedirectImage, {
                loader: function(param) {
                    var src = param.src;
                    return src;
                },
                unoptimized: true,
                width: 54,
                height: 54,
                src: "".concat(redirectImage),
                alt: "back-image"
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowBackIos/* default */.Z, {})
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/components/GameFrame/GameFrame.tsx























var IconButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(IconButton/* default */.Z, {
    target: "e2ou40i0"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.primary.main,
        "& svg": {
            fill: theme.palette.primary.contrastText,
            fontSize: theme.typography.button.fontSize
        },
        zIndex: 1201,
        width: "30px",
        height: "30px",
        left: "10px",
        top: "50px"
    };
});
var NextLevelModal = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "e2ou40i1"
})(function(param) {
    var theme = param.theme;
    return {
        zIndex: 5,
        background: "rgba(0, 0, 0, 0.5)",
        width: "100%",
        display: "flex",
        alignItems: "start",
        justifyContent: "center"
    };
})));
var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2ou40i2"
})("display:flex;flex-grow:1;overflow:auto;position:relative;z-index:inherit;top:auto;bottom:auto;right:auto;left:auto;aspect-ratio:16/9;margin:0;width:100%;", function(props) {
    return props.fullscreen && {
        overflow: "hidden",
        position: "fixed",
        zIndex: 2,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        aspectRatio: "unset"
    };
}, ";", function(props) {
    return props.fixedHeight && {
        height: "600px",
        aspectRatio: "1"
    };
}, ";");
var GameFrame = function(props) {
    var game = props.game, _start = props.start, start = _start === void 0 ? false : _start, _enableOrientationLock = props.enableOrientationLock, enableOrientationLock = _enableOrientationLock === void 0 ? false : _enableOrientationLock, _enableDraggableMenu = props.enableDraggableMenu, enableDraggableMenu = _enableDraggableMenu === void 0 ? false : _enableDraggableMenu, _enableResponsive = props.enableResponsive, enableResponsive = _enableResponsive === void 0 ? false : _enableResponsive, onStop = props.onStop, fixedHeight = props.fixedHeight;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(new utils_ancestor/* default */.Z()), 1), ancestor = ref[0];
    var i18n = (0,useTranslation/* useTranslation */.$)().i18n;
    var container = react.useRef(null);
    var iframe = /*#__PURE__*/ react.createRef();
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState({
        started: false,
        src: "",
        width: "100%",
        height: "100%",
        elementWidth: "100%",
        elementHeight: "100%",
        menu: false,
        orientation: types_enum/* GameOrientationEnum.ANY */.lD.ANY
    }), 2), frame = ref1[0], setFrame = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("lastplayed:current", []), 2), gamesCurrent = ref2[0], setGamesCurrent = ref2[1];
    var toggleMenu = react.useCallback(function() {
        var handler = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                unsetScreenLock()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            // Silently fail.
                            console.error(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            // Todo: Currently don't have a menu interface. So lets just close the game.
                            setFrame(function(state) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    menu: !state.menu,
                                    started: false
                                });
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function handler() {
                return _ref.apply(this, arguments);
            };
        }();
        handler();
        if (onStop) {
            onStop(frame.started);
        }
    }, [
        setFrame
    ]);
    var addGameToLastPlayed = function(game) {
        var isAlreadyExist = gamesCurrent.some(function(element) {
            return element.id === game.id;
        });
        if (isAlreadyExist) {
            var index = gamesCurrent.findIndex(function(element) {
                return element.id === game.id;
            });
            if (index === 0) return; // Game already exists and is the first one already.
            // Move the game to the top of the list.
            var item = gamesCurrent.splice(index, 1);
            // @ts-ignore Todo: Not sure how to fix this typescript issue.
            gamesCurrent.unshift(item);
        } else {
            if (gamesCurrent.length > 5) gamesCurrent.pop(); // Only max out the list to 5 items.
            gamesCurrent.unshift(game);
            setGamesCurrent((0,_to_consumable_array/* default */.Z)(gamesCurrent));
        }
    };
    react.useEffect(function() {
        setFrame(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                started: start
            });
        });
    }, [
        start
    ]);
    react.useEffect(function() {
        var overwrite = HARDCODED_GAMES.find(function(item) {
            return item.code === game.code;
        });
        var orientation = game.orientation;
        if (overwrite && overwrite.orientation) {
            orientation = overwrite.orientation;
        }
        setFrame(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                orientation: orientation
            });
        });
        if (game.src) {
            var ref;
            var src = game.src;
            // Need to set the "gd_sdk_referrer_url" parameter. As referrer header will not be present all the time.
            // It is needed for reporting purposes. The page href is preferred over the site origin.
            src = addOrReplaceParam(src, "gd_sdk_referrer_url", ((ref = ancestor.context) === null || ref === void 0 ? void 0 : ref.url) || document.location.href || document.location.origin);
            // Add language parameter, for usage by the GD SDK and Google IMA SDK.
            src = addOrReplaceParam(src, "lang", i18n.language);
            setFrame(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    src: src
                });
            });
        }
    }, [
        game,
        i18n.language
    ]);
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), openNextLevelModal = ref3[0], setOpenNextLevelModal = ref3[1];
    react.useEffect(function() {
        /**
     * Special logic for SoftGames crossword puzzles. We need to set our game frame
     * height for these games, as they are not responsive.
     * They send a PostMessage event with the height based on mobile agents.
     */ var messageHandler = function(event) {
            if (event.origin === "https://games.softgames.com" || event.origin === "https://html5.gamedistribution.com") {
                try {
                    ;
                    ;
                    var data = typeof event.data === "object" ? event.data : undefined;
                    if (data && data.height) {
                        setFrame(function(state) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                height: "".concat(data.height, "px"),
                                elementHeight: data.height,
                                orientation: types_enum/* GameOrientationEnum.PORTRAIT */.lD.PORTRAIT
                            });
                        });
                        if (container.current) {
                            container.current.style.overflow = "auto";
                        }
                    }
                    if (data.eventName === "levelFinish" && componentOptions.component_gamescreen_next_level_modal) {
                        setOpenNextLevelModal(true);
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        };
        if (frame.src !== "" && (frame.src.includes("https://games.softgames.com") || frame.src.includes("https://html5.gamedistribution.com"))) {
            window.addEventListener("message", messageHandler);
        }
        return function() {
            if (frame.src !== "" && (frame.src.includes("https://games.softgames.com") || frame.src.includes("https://html5.gamedistribution.com"))) {
                window.removeEventListener("message", messageHandler);
                if (container.current) {
                    container.current.style.overflow = "hidden";
                }
            }
        };
    }, [
        frame.src
    ]);
    react.useEffect(function() {
        var resizeHandler = function() {
            setFrame(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    width: "".concat(document.documentElement.clientWidth, "px"),
                    height: "".concat(document.documentElement.clientHeight, "px"),
                    elementWidth: document.documentElement.clientWidth,
                    elementHeight: document.documentElement.clientHeight
                });
            });
        };
        if (frame.started && enableResponsive) {
            resizeHandler();
            window.addEventListener("resize", resizeHandler);
        } else {
            window.removeEventListener("resize", resizeHandler);
        }
        return function() {
            window.removeEventListener("resize", resizeHandler);
        };
    }, [
        setFrame,
        frame.started,
        enableResponsive
    ]);
    react.useEffect(function() {
        if (frame.started && iframe.current) {
            iframe.current.focus();
        }
    }, [
        frame.started,
        iframe
    ]);
    react.useEffect(function() {
        if (frame.started) {
            addGameToLastPlayed(game);
        }
    }, [
        game,
        frame.started
    ]);
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref4 = appContext.useConfig(), assetUrl = ref4.assetUrl, componentOptions = ref4.componentOptions;
    if (!frame.started) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var redirectButtonShow = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_gamescreen_redirect_back_button_show;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        style: {
            zIndex: dist_lib/* isMobile */.tq ? "1200" : ""
        },
        ref: container,
        fullscreen: enableOrientationLock,
        fixedHeight: fixedHeight,
        children: [
            enableOrientationLock && container.current && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrientationLock, {
                fullscreenElement: container.current,
                zIndex: 3,
                orientation: frame.orientation
            }),
            enableDraggableMenu && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButtonStyled, {
                className: "closebutton",
                onClick: toggleMenu,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* default */.Z, {})
            }),
            openNextLevelModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StagePopup, {
                iconUrl: "".concat(assetUrl).concat(game.images.cover1x1 || game.images.cover, "/"),
                name: "".concat(game.name),
                closePopUp: function() {
                    return setOpenNextLevelModal(false);
                }
            }),
            redirectButtonShow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RedirectBackButton, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Frame, {
                ref: iframe,
                src: frame.src,
                elementWidth: frame.elementWidth,
                elementHeight: frame.elementHeight,
                width: frame.width,
                height: frame.height
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js
var emotion_element_cbed451f_browser_esm = __webpack_require__(54880);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ControlPoint.js
var ControlPoint = __webpack_require__(67408);
;// CONCATENATED MODULE: ./src/components/GameFrame/LeftCarousel.tsx











var LeftCarouselContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jtj43a0"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ".plus-warning-contained": {
            margin: "0 auto"
        }
    }, theme.breakpoints.down(1500), {
        display: "none"
    });
});
var CarouselList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7397), __webpack_require__.e(3091), __webpack_require__.e(766)]).then(__webpack_require__.bind(__webpack_require__, 24905)).then(function(mod) {
        return mod.CarouselList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24905)
            ];
        }
    },
    ssr: false
});
var LeftCarousel = function(param) {
    var games = param.games;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var carouselLeftSideShow = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_gamescreen_left_game_carousel_show;
    var carouselLeftSideButtonRedirect = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_gamescreen_left_game_carousel_button_redirect;
    var carouselLeftSideButtonText = (componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_gamescreen_left_game_carousel_button_text) || "Recommended Games";
    if (carouselLeftSideShow) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: Array.isArray(games) && games.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LeftCarouselContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        href: carouselLeftSideButtonRedirect || "/",
                        color: "inherit",
                        variant: "inherit",
                        underline: "none",
                        title: "",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                            color: "warning",
                            variant: "contained",
                            className: "plus-warning-contained",
                            children: [
                                carouselLeftSideButtonText,
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ControlPoint/* default */.Z, {
                                    style: {
                                        marginLeft: "8px"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselList, {
                        padding: theme.spacing(2),
                        items: games,
                        direction: "vertical",
                        cardOptions: {
                            width: componentOptions.component_card_width || 512,
                            height: componentOptions.component_card_height || 288,
                            sizes: "(min-width:1200px) 16.666vw, (min-width:900px) 25vw, (min-width:600px) 33.333vw, 50vw",
                            layout: "responsive",
                            template: (componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_game_carousel_card_type) || types_enum/* CardTypeEnum.SIMPLE */.mq.SIMPLE
                        }
                    })
                ]
            })
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    }
};

;// CONCATENATED MODULE: ./src/components/GameFrame/index.ts





/***/ })

}]);